/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/

import { ApiKeyFetch } from "api/fetchers/apiKey";
import { URLS_PHP_7 } from "constants/urls_v2";
import useCustomToast from "hooks/useCustomToasts";
import useQueryParams from "hooks/useQueryParams";
import _ from "lodash";
import React, { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import useParametrosPago from "redux/hooks/useParametrosPago";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import Loading from "../../wrappers/Loading";

const ContainerRecuperarPoliza = () => {
  const { idPoliza, prodCodigo } = useQueryParams();
  const history = useHistory();

  const { addWarningToast } = useCustomToast();

  const { dataUsuario } = useSelector((state) => state.datosUsuarios);
  const { fetchParametros } = useParametrosPago();
  const init = useCallback(async () => {
    if (prodCodigo === PRODUCTOS.CASUALITY) {
      return history.push(`/recuperar-cotizacion-casualitycontratistas?idPoliza=${idPoliza}`);
    }
    if (prodCodigo === PRODUCTOS.CASUALITY_GENERAL) {
      return history.push(`/recuperar-cotizacion-casualitygenerales?idPoliza=${idPoliza}`);
    }
    const Data = {
      datosCotizador: {
        ambiente: 'desarrollo',
        cotPasoCodigo: 'recuperarPolizaIncompleta',
        polCodigo: idPoliza,
        prodCodigo,
        usuCotiza: { usuCodigo: dataUsuario.cliCodigoCore },
      },
    };
    console.log('DATA: ', Data);
    fetchParametros();
    const res = await ApiKeyFetch.instance().post(URLS_PHP_7.emision.datosEmision, Data);

    console.log('RES RECUPERAR: ', res);
    // return;
    if (res.transaccion) {
      if (res?.catalogo?.redireccionar === true) {
        const pasos = res.catalogo.pasosRedireccionamiento;
        console.log('PASOS: ', res.catalogo.pasosRedireccionamiento);
        const noCompletados = pasos.filter((e) => {
          return e.completado !== true;
        });

        console.log('NO COMPLETADOS: ', noCompletados);
        if (noCompletados.length > 0) {
          const pasoRecuperado = _.minBy(noCompletados, 'orden');
          const pasoAnterior = pasos.find((e) => e.orden === pasoRecuperado.orden - 1);
          //Agregado para las redirecciones en productos LF, Pymes
          let ramo = prodCodigo;
          switch (ramo) {
            case 'RCP':
              ramo = 'lnPresRcp';
              break;
            case 'RCPA':
              ramo = 'lnPresRcpa';
              break;

            default:
              break;
          }
          let urlGoTo = `${pasoAnterior.goTo}&codProducto=${prodCodigo}&ramo=${ramo}`;
          if (prodCodigo === 'pymesAbiertoInd') {
            urlGoTo = `${pasoAnterior.goTo}`;
          }
          return history.replace(urlGoTo);
        } else {
          addWarningToast('Esta póliza ya ha sido completada');
          return history.push('/listado-polizas');
        }
      } //IF VALIDA RECUPERAR

      addWarningToast(res?.catalogo?.mensajeRedireccion);
      return history.push('/');
    } else {
      addWarningToast('Ha ocurrido un problema al recuperar la póliza');
      history.replace('/listado-polizas');
    }
  }, []);

  useEffect(() => {
    init();
  }, []);

  return <Loading loading={true} message="Recuperando Póliza..." />;
};

export default ContainerRecuperarPoliza;
